import { Spacing } from "../../../foundations/spacing.es.js";
const ACTIVE_PADDING = `${Spacing["750"]} ${Spacing["1500"]}`;
const MOBILE_PADDING = Spacing["0"];
function getProfileQuestionnaireItemWrapperPadding({
  isMobile,
  isActive
}) {
  if (isMobile) {
    return MOBILE_PADDING;
  }
  return isActive ? ACTIVE_PADDING : MOBILE_PADDING;
}
export {
  ACTIVE_PADDING,
  MOBILE_PADDING,
  getProfileQuestionnaireItemWrapperPadding
};
//# sourceMappingURL=get-profile-questionnaire-item-wrapper-padding.es.js.map
